import { IconClockMin, IconLevel } from "@/components/icon/master";
import { TCocktailDetailProps } from "../type"
import { TCocktail, TIconLevel } from "@/shared/types";

export function CocktailCraftMethods(props: TCocktailDetailProps & { cocktailInfo: TCocktail }) {
    const { cocktailInfo } = props;
    return <div className="cocktail-craft-methods-wrapper">
        <div className="top-title-wrapper">
            <h2 className="methods-title sub-title">{props.titleHowToCraft}</h2>
            <div className="craft-tags">
                {
                    cocktailInfo.preparationTime && <div className="craft-tag">
                        <IconClockMin />
                        <span className="tag-text">{cocktailInfo.preparationTime} {props.unitPrepareTime}</span>
                    </div>
                }
                {
                    cocktailInfo.difficulty && <div className="craft-tag">
                        <IconLevel level={cocktailInfo.difficulty as TIconLevel} />
                        <span className="tag-text">{cocktailInfo.difficulty}</span>
                    </div>
                }
            </div>
        </div>
        <div className="bottom-methods-wrapper">
            <div className="methods-list">
                {
                    cocktailInfo?.method?.map((item, index) => (
                        <div className="method-item" key={index}>
                            <div className="left-number">0{index + 1}</div>
                            <div className="right-desc">{item.methodStep}</div>
                        </div>
                    ))
                }
            </div>
            {
                cocktailInfo?.recipeSecondImage?.url && <div className="craft-media-wrapper">
                    <img src={cocktailInfo?.recipeSecondImage?.url} alt="craft media" />
                </div>
            }

        </div>


    </div>
}